/* eslint-disable default-param-last */
import { SHOW_VENDOR_DETAILS } from 'actionTypes/vendorDetailsActionTypes';

const initialState = {
  status: false,
  selectedVendor: null,
};

const vendorDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_VENDOR_DETAILS:
      return {
        ...state,
        status: action.payload.status,
        selectedVendor: action.payload.selectedVendor,
      };
    default:
      return state;
  }
};

export default vendorDetailsReducer;
